import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../../axiosInstance";
import { CompanyProfileData } from "../../../components/Models/CompanyProfileData";

interface useGetTermsRequestsProps {
  userId: string;
  enabled?: boolean;
}

export function useGetCompanyDetails({
  userId,
  enabled = true,
}: useGetTermsRequestsProps) {
  return useQuery({
    enabled,
    queryKey: ["company-data", userId],
    queryFn: async () => {
      return axiosInstance<CompanyProfileData[]>(
        getAPIURL(`/MuslimInvestProfile/Company/by-user/${userId}`)
      ).then((response) => response.data);
    },
  });
}
